import { $get, $set } from '@makeabledk/vue-ui/support/helpers'
import { Observable, fromEvent, merge, of } from 'rxjs'
import { map, sampleTime } from 'rxjs/operators'
import TailwindProvider from '@makeabledk/vue-ui/providers/tailwind-provider'

export default class ResponsiveValue {
    constructor(value = null) {
        this.sizes = {}

        if (value !== null) {
            this.default(value)
        }
    }

    static create(value) {
        if (typeof value === 'undefined' || value === null) {
            return null
        }

        if (value instanceof Observable) {
            return value
        }

        if (value instanceof Object) {
            const responsive = new ResponsiveValue()

            Object.keys(value).forEach((key) => responsive[key](value[key]))

            return responsive.get()
        }

        return new ResponsiveValue(value).get()
    }

    default(value) {
        $set(this.sizes, '0', value)
        return this
    }

    xs(value) {
        return this._set('xs', value)
    }

    sm(value) {
        return this._set('sm', value)
    }

    md(value) {
        return this._set('md', value)
    }

    lg(value) {
        return this._set('lg', value)
    }

    xl(value) {
        return this._set('xl', value)
    }

    get() {
        return merge(
            of(this._getValueForClientWidth(window.innerWidth)),
            fromEvent(window, 'resize')
                .pipe(sampleTime(100))
                .pipe(map((e) => this._getValueForClientWidth(e.target.innerWidth)))
        )
    }

    _set(screen, value) {
        $set(this.sizes, this._pixels(TailwindProvider.config(`theme.screens.${screen}`)), value)
        return this
    }

    _pixels(value) {
        return value.replace('px', '')
    }

    _getValueForClientWidth(width) {
        const applicableThresholds = Object.keys(this.sizes).filter((threshold) => threshold <= width)

        if (applicableThresholds.length >= 0) {
            return $get(this.sizes, applicableThresholds[applicableThresholds.length - 1])
        }

        return null
    }
}
